module.exports = {
    etherscan: {
        tx: `https://etherscan.io/tx`,
        account: `https://etherscan.io/address`
    },
    api: {
        game_url: `https://api-lok-test.leagueofkingdoms.com/api`,
        stat_url: `https://api-stats.leagueofkingdoms.com/api`,
        nft_url: `https://lok-dev-nft.leagueofkingdoms.com/api`,
    },
    web: {
        url: `https://land-test.leagueofkingdoms.com`        
    },
    card: {
        url: `https://lok-dev-nft.leagueofkingdoms.com/api/card/land`
    },
    eth: {
        net: 4,
        networks:["mainnet", "mainnet", "", "ropsten", "rinkeby"]
    },
    abi: {
        sale: require('./views/KingdomLandSale.json')
    }
}